import { MultiSelectItem } from './multi-select-item';
import { CustomDataAdaptor } from '@syncfusion/ej2-data';
import { Observable } from 'rxjs';
import { fakeHttpRequest } from '../fakeHttpRequest';

export class MultiSelectCustomAdaptor extends CustomDataAdaptor {
  constructor(private getDataFunction: (searchText: string) => Observable<string[] | MultiSelectItem[]>) {
    super();
    this.options.getData = this.getData.bind(this);
  }

  private getData(args) {
    const data = JSON.parse(args.data);
    if (this.getDataFunction == null) {
      args.onFailure('getDataFunction is null');
    }

    this.getDataFunction(data.where ? data.where[0].value : null).subscribe({next: (result: string[]) => {
        args.onSuccess(result, {httpRequest: new fakeHttpRequest()});
      }, error: (error) => {
        args.onFailure('getData failed');
      }});
  }
}
